
<template>
  <div>
    <div class="agInputGroup agInputGroupCentered">
      <label>Connection:</label>
      <b-form-select
        class="agLargeInput"
        v-model="geoInput.connection"
        :options="connections"
        :disabled="disableUI || isUpdatingSchemas"
        @change="connectionField_change"
      ></b-form-select>
    </div>
    <div class="agInputGroup">
      <b-input-group size="md" prepend="Record URL">
        <b-input type="text" v-model="geoInput.config.recordUrl" autocomplete="false" :disabled="disableUI"></b-input>
        <button class="agImageButton" @click="urlButton_click" :disabled="disableUI">
          <fa icon="share" />
        </button>
      </b-input-group>
    </div>
    <div class="agInputGroup">
      <label>URL Parameters:</label>
      <b-table
        v-if="showParams"
        :key="'params-' + reloadParams"
        id="agGISExtension-paramsTable"
        :fields="paramHeaders"
        :items="geoInput.config.params"
        :disabled="disableUI"
        borderless
        outlined
        small
      >
        <template #cell(param)="data">
          <b-input type="text" :value="data.item.name" autocomplete="false" disabled></b-input>
        </template>
        <template slot="=">
          <div class="agGISExtension-equals">=</div>
        </template>
        <template #cell(value)="data">
          <ag-input-select
            :inputModel="data.item.value.value"
            :selectModel="data.item.value.field"
            :useSubInput="true"
            :workflow="workflow"
            :groups="paramValues"
            :width="260"
            :disabled="disableUI"
            @input_keyup="paramValueInput_keyup($event, data.item)"
            @select_change="paramValueSelect_change($event, data.item)"
          ></ag-input-select>
        </template>
      </b-table>
      <div v-if="showNoParams" class="agInputGroupCentered">
        <label class="danger">No URL parameters were found</label>
      </div>
    </div>
    <div class="agInputGroup">
      <label>Fields:</label>
      <b-table
        v-if="showFields"
        id="agGISExtension-fieldsTable"
        :fields="mapHeaders"
        :items="fields"
        :thead-class="{'theadHidden': isUpdatingSchemas }"
        borderless
        outlined
        small
      >
        <template #head(enabled)>
          <input
            type="checkbox"
            v-model="fieldsEnableAll"
            :disabled="disableUI"
            @click="fieldsEnableAll_click"
          />
        </template>
        <template #cell(enabled)="data">
          <input
            type="checkbox"
            v-model="data.item.enabled"
            class="agGISExtension-fieldCheckbox"
            :disabled="disableUI"
          />
        </template>
        <template #cell(field)="data">
          <b-input type="text" :value="data.item.key" autocomplete="false" disabled></b-input>
        </template>
        <template slot="=">
          <div class="agGISExtension-equals">=</div>
        </template>
        <template #cell(name)="data">
          <b-input type="text" v-model="data.item.name" autocomplete="false" :disabled="disableUI"></b-input>
        </template>
      </b-table>
      <b-spinner v-if="isUpdatingSchemas" id="agGISExtension-fieldsTableSpinner"></b-spinner>
      <div v-if="showNoFields" class="agInputGroupCentered">
        <label class="danger">No fields were found</label>
      </div>
    </div>
  </div>
</template>






<script>
// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Server from "src/server";
import Util from "src/util/util";

export default {
  name: "ag-geoInput-gisExtension",
  components: {
    "ag-input-select": InputSelect
  },
  props: {
    disableUI: Boolean,
    workflow: Object,
    geoInput: Object
  },
  data() {
    return {
      isUpdatingSchemas: false,
      reloadParams: 0,
      showParams: false,
      showNoParams: false,
      showFields: false,
      showNoFields: false,
      paramHeaders: [
        { key: "param", label: "Parameter" },
        { key: "=", label: "=" },
        { key: "value", label: "Value" }
      ],
      paramValues: {},
      mapHeaders: ["enabled", "field", "=", "name"],
      fields: {},
      fieldsCancel: null,
      fieldsEnableAll: false
    };
  },

  computed: {
    connections() {
      var connections = [{ value: "-- None --", text: "-- None --" }];
      var gisConnections = this.$store.getters["connStore/getGISConns"];
      for (var i = 0; i < gisConnections.length; i++) {
        var conn = gisConnections[i];
        var connItem = { value: conn, text: conn.name };
        connections.push(connItem);

        if (
          this.geoInput.connection &&
          conn._id == this.geoInput.connection._id
        ) {
          this.geoInput.connection = conn;
        }
      }
      return connections;
    }
  },

  watch: {},

  created() {},

  mounted() {},

  methods: {
    // UI Events

    connectionField_change(value) {
      if (value == "-- None --") this.geoInput.connection = null;
    },

    urlButton_click() {
      this.setParams();
      this.setFields();
      this.reloadParams++;
    },

    paramValueInput_keyup(value, param) {
      param.value.value = value;
      param.value.field = null;
    },

    paramValueSelect_change(value, param) {
      param.value.field = value;
      param.value.value = null;
    },

    fieldsEnableAll_click(e) {
      var enabled = e.currentTarget.checked;
      for (var i = 0; i < this.fields.length; i++) {
        var field = this.fields[i];
        field.enabled = enabled;
      }
    },

    // emitted Events

    // other

    reset() {
      // init config object if it's empty
      if (Object.keys(this.geoInput.config).length == 0) {
          this.geoInput.config = {
              params: null,
              fieldMap: null,
              fields: []
          };
      }

      this.setParams();
      this.setParamValues();
      this.setFields();
      this.reloadParams++;
    },

    prepareForSave() {
      // build fields and fieldmap w/ checked fields
      this.geoInput.config.fields = [];
      this.geoInput.config.fieldMap = {};
      for (var i = 0; i < this.fields.length; i++) {
        var field = this.fields[i];
        if (field.enabled) {
          this.geoInput.config.fields.push(field.name);
          this.geoInput.config.fieldMap[field.name] = field.sub;
        }
      }
    },

    setParams() {
      this.showParams = false;
      this.showNoParams = false;
      var params = [];

      if (!this.geoInput.config.recordUrl) return;

      var url = new URL(this.geoInput.config.recordUrl);
      var iterator = url.searchParams.entries();
      for (var keyValue of iterator) {
        var param = keyValue[0];
        var value = keyValue[1];
        var existing;
        if (this.geoInput.config.params)
          existing = this.geoInput.config.params.find(a => a.name == param);

        if (existing) params.push({ name: param, value: existing.value });
        else params.push({ name: param, value: { value: value, field: null } });
      }
      this.geoInput.config.params = params;
      if (params.length == 0) this.showNoParams = true;
      else this.showParams = true;
    },

    setParamValues() {
      this.paramValues = {};

      // inputs
      for (var i = 0; i < this.workflow.inputs.length; i++) {
        var input = this.workflow.inputs[i];
        var name = input.shortname;
        if (input.name) {
          name += ": " + input.name;
        }

        var options = [];
        for (var j = 0; j < input.fields.length; j++) {
          var field = input.fields[j];
          var option = {
            value: { input: input.shortname, field: field },
            text: input.shortname + ": " + field
          };
          options.push(option);
        }
        this.paramValues[name] = options;
      }

      // geoInputs
      for (var i = 0; i < this.workflow.geoInputs.length; i++) {
        var geoInput = this.workflow.geoInputs[i];
        var name = geoInput.shortname;
        if (geoInput.name) {
          name += ": " + geoInput.name;
        }

        if (!geoInput.config || !geoInput.config.fields) continue;

        var options = [];
        for (var j = 0; j < geoInput.config.fields.length; j++) {
          var field = geoInput.config.fields[j];
          var option = {
            value: { input: geoInput.shortname, field: field },
            text: geoInput.shortname + ": " + field
          };
          options.push(option);
        }
        this.paramValues[name] = options;
      }

      // outputs
      for (var i = 0; i < this.workflow.outputs.length; i++) {
        var output = this.workflow.outputs[i];
        var name = output.shortname;
        if (output.name) {
          name += ": " + output.name;
        }

        var options = [];
        for (var j = 0; j < output.fields.length; j++) {
          var field = output.fields[j];
          var option = {
            value: { input: output.shortname, field: field },
            text: output.shortname + ": " + field
          };
          options.push(option);
        }
        this.paramValues[name] = options;
      }
    },

    async setFields() {
      this.showFields = false;
      this.showNoFields = false;
      this.fields = [];
      if (!this.geoInput.config.recordUrl) return;

      if (this.fieldsCancel) {
        this.fieldsCancel("cancel previous 'getGISDataFromUrl' call");
        this.fieldsCancel = null;
      }

      try {
        this.showFields = true;
        this.isLoadingFields = true;
        var url =
          "getGISDataFromUrl?url=" +
          encodeURIComponent(this.geoInput.config.recordUrl);
        if (this.geoInput.connection)
          url += "&conn=" + this.geoInput.connection._id;
        var req = Server.get(url);
        this.fieldsCancel = req.cancel;
        var result = await req.promise;
        this.isLoadingFields = false;
        if (!result.data.success) throw result.data.error;

        var data = result.data.data;
        let expanded = Util.expandJSON(data);
        for (var key in expanded) {
          var enabled = false;
          var name = key;
          var sub = expanded[key].sub;
          if (this.geoInput.config.fieldMap) {
            var keys = Object.keys(this.geoInput.config.fieldMap);
            var field = keys.find(a => this.geoInput.config.fieldMap[a] == sub);
            if (field) {
              enabled = true;
              name = field;
            }
          }
          this.fields.push({
            enabled: enabled,
            key: key,
            name: name,
            sub: sub
          });
        }
      } catch (e) {
        console.log(
          "Failed to read from " +
            this.geoInput.config.recordUrl +
            ". Error: " +
            e.toString()
        );
        this.isLoadingFields = false;
      }

      if (this.fields.length == 0) {
        this.showFields = false;
        this.showNoFields = true;
      }
    }
  }
};
</script>






<style scoped lang="css">

#agGISExtension-paramsTable {
  display: inline-block;
  vertical-align: top;
  text-align: center;
  width: calc(100% - 135px);
  height: 175px;
  overflow: auto;
  border-collapse: collapse;
}

#agGISExtension-fieldsTable {
  display: inline-block;
  vertical-align: top;
  text-align: center;
  width: calc(100% - 105px);
  height: 175px;
  overflow: auto;
  border-collapse: collapse;
}

#agGISExtension-fieldsTableSpinner {
  position: relative;
  left: 420px;
  top: -120px;
}

#agGISExtension-paramsTable input,
#agGISExtension-fieldsTable input {
  width: 260px;
}

#agGISExtension-paramsTable .agInputSelect {
  margin: auto;
}

.agGISExtension-fieldCheckbox {
  margin-top: 10px;
}

.agGISExtension-equals {
  width: 50px;
  margin-top: 7.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/nodes/geoInputs/GISExtension.vue